import { useState, useEffect } from 'react'
import { useRequests } from '../requests/useRequests'
import { Conversation } from '../types/messages'

export const useConversations = () => {
  const requests = useRequests()
  const [conversations, setConversations] = useState<Conversation[]>([])
  const [loading, setLoading] = useState<boolean>(false)
  const [error, setError] = useState<string | null>(null)
  const [selectedConversation, setSelectedConversation] = useState<number | null>(null)

  // Funkcja do pobierania konwersacji
  const fetchConversations = async () => {
    try {
      setLoading(true)
      const response = await requests.getConversations()
      setConversations(response.data)
    } catch (err) {
      console.error('Błąd podczas pobierania konwersacji:', err)
      setError('Nie udało się pobrać konwersacji. Spróbuj ponownie później.')
    } finally {
      setLoading(false)
    }
  }

  // Pobieranie listy konwersacji
  useEffect(() => {
    fetchConversations()
  }, [requests])

  // Funkcja do aktualizacji liczby nieprzeczytanych wiadomości
  const updateUnreadCount = (conversationId: number) => {
    setConversations(prevConversations =>
      prevConversations.map(conv => {
        if (conv.id === conversationId) {
          return { ...conv, unreadCount: 0 }
        }
        return conv
      })
    )
  }

  // Funkcja do aktualizacji ostatniej wiadomości
  const updateLastMessage = (conversationId: number, message: string, hasAttachment: boolean = false) => {
    setConversations(prevConversations =>
      prevConversations.map(conv => {
        if (conv.id === conversationId) {
          return {
            ...conv,
            lastMessage: message || (hasAttachment ? 'Załącznik' : ''),
            lastMessageTime: new Date().toISOString(),
            hasAttachment
          }
        }
        return conv
      })
    )
  }

  return {
    conversations,
    setConversations,
    loading,
    error,
    selectedConversation,
    setSelectedConversation,
    fetchConversations,
    updateUnreadCount,
    updateLastMessage
  }
}
